import { render, staticRenderFns } from "./SmarteduMenuItem.vue?vue&type=template&id=42b95832"
import script from "./SmarteduMenuItem.vue?vue&type=script&lang=ts"
export * from "./SmarteduMenuItem.vue?vue&type=script&lang=ts"
import style0 from "./SmarteduMenuItem.vue?vue&type=style&index=0&id=42b95832&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports